import { render, staticRenderFns } from "./crudReminders.vue?vue&type=template&id=69f5242a&"
import script from "./crudReminders.vue?vue&type=script&lang=js&"
export * from "./crudReminders.vue?vue&type=script&lang=js&"
import style0 from "./crudReminders.vue?vue&type=style&index=0&id=69f5242a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports